import React from 'react';
import { Box, Tooltip } from '@mui/material';

// Küçük yuvarlak gösterge
const DeviceStatusIndicator = ({ isActive }) => (
  <Tooltip title={isActive ? 'Cihaz Aktif' : 'Cihaz Pasif'} placement="right">
    <Box
      sx={{
        width: 18,
        height: 18,
        borderRadius: '50%',
        backgroundColor: isActive ? '#4caf50' : '#f44336',
        border: '2px solid #fff',
        boxShadow: '0 0 0 2px rgba(0,0,0,0.08)',
        display: 'inline-block',
      }}
      data-testid="device-status-indicator"
    />
  </Tooltip>
);

export default DeviceStatusIndicator;
